export default __webpack_public_path__ + "8bfc6116fb0f53198c949f744088a5ce.jpg";